<template>
    <v-row justify="center" class="ma-n1">
        <v-col cols="auto" class="pa-1">
            <v-btn outlined width="150" :color="form.isGranted == true ? 'primary' : 'grey-d'" @click="emit(true)">
                <span :class="{ 'grey--text': form.isGranted != true }"> 승인 </span>
            </v-btn>
        </v-col>
        <v-col cols="auto" class="pa-1">
            <v-btn outlined width="150" :color="form.isGranted != true ? 'primary' : 'grey-d'" @click="emit(false)">
                <span :class="{ 'grey--text': form.isGranted == true }"> 거부 </span>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { initExpoMatching } from "@/assets/variables/inits";

export default {
    props: {
        value: { type: Object, default: initExpoMatching }, // form
    },
    data: () => ({
        form: initExpoMatching(),
    }),
    methods: {
        sync() {
            this.form = initExpoMatching(this.value);
        },
        emit(isGranted) {
            this.form.isGranted = isGranted;
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>
